import { ChevronUp } from 'lucide-react'

import { cn } from '@/frontend/lib/utils'

/** Stacked chevron icon indicating urgency level (1-3). */
export function ChevronsIcon({
  level,
  className,
}: {
  level: 1 | 2 | 3
  className?: string
}) {
  return (
    <span className={cn('inline-flex flex-col items-center justify-center', className)}>
      {Array.from({ length: level }, (_, i) => (
        <ChevronUp key={i} className="size-3 -my-[4px]" />
      ))}
    </span>
  )
}
